// Third-party imports
import Aos from 'aos';

import injectRegistrationScripts, { injectOtherScripts } from './helpers/registrationScripts';
import { getCookieValue, setCookie } from './helpers/cookie';
import loadBook from './helpers/book';
import { setTapNativeCookieIfRequired } from './helpers/tapNativeTracker';
import adBanner from './components/ad-banner';

// import selectDropdown from './components/select-dropdown';

const header = document.querySelector('.header');
const fixed = document.getElementById('header').offsetTop;
const bookCard = document.querySelector('.feature-img');

window.addEventListener('scroll', () => {
  if (!header) return;
  if (window.pageYOffset > fixed) {
    if (!header.classList.contains('fixed')) {
      header.classList.add('fixed');
    }
  } else if (header.classList.contains('fixed')) {
    header.classList.remove('fixed');
  }
});

function toggleMobileMenu() {
  document.querySelector('.header').classList.toggle('is-menu-open');
  document.body.classList.toggle('no-scroll');
  document.querySelector('.webpage').classList.toggle('no-scroll');
  document.querySelector('.mobile-popups').classList.toggle('show');
}

function toggleCookieBanner() {
  const EUROPEAN_COUNTRY_CODES = [
    'AL',
    'AD',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'EL',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IS',
    'IE',
    'IT',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MD',
    'MC',
    'ME',
    'NL',
    'MK',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SM',
    'RS',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'TR',
    'UA',
    'GB',
    'UK',
  ];
  const cookieBanner = document.querySelector('.cookie-banner');
  const cookieCloseBtn = document.querySelector('#cookie-close-btn');

  if (
    window.siteInfo
    && EUROPEAN_COUNTRY_CODES.includes(window.siteInfo.country)
    && cookieBanner
  ) {
    if (!getCookieValue('isCookieBannerClosed')) {
      cookieBanner.classList.add('show');
      cookieCloseBtn.addEventListener('click', () => {
        setCookie('isCookieBannerClosed', true, 365);
        cookieBanner.classList.remove('show');
      });
    }
  }
}

function accordionHandler(event) {
  const { target } = event;

  const accordionWrappers = document.querySelectorAll('.accordion-wrapper');
  const currentAccordionWrapper = target.closest('.accordion-wrapper');
  if (!currentAccordionWrapper) return;

  if (!currentAccordionWrapper.classList.contains('is-open')) {
    accordionWrappers.forEach(item => item.classList.remove('is-open'));
    currentAccordionWrapper.classList.add('is-open');
  } else {
    currentAccordionWrapper.classList.remove('is-open');
  }
  currentAccordionWrapper.scrollIntoView({ behaviour: 'smooth' });
}

function smoothScrollSection() {
  const scrollTrigger = document.querySelector('.scroll-down-arrow');
  const scrollTarget = scrollTrigger.getAttribute('href');
  scrollTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector(scrollTarget).style.scrollMargin = '84px';
    document.querySelector(scrollTarget).scrollIntoView({ behavior: 'smooth' });
  });
}

function injectOnView() {
  if (window.pageYOffset >= 300) {
    injectRegistrationScripts();
    injectOtherScripts();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  // Aos animation init
  Aos.init({ offset: 40 });
  adBanner();

  const accordionItems = document.querySelectorAll('.accordion-wrapper');
  accordionItems.forEach((accordionList) => {
    const accordionHeader = accordionList.querySelector('.accordion');
    if (!accordionHeader) return;
    accordionHeader.addEventListener('click', accordionHandler);
  });
  // Mobile menu toggle
  const menuToggle = document.querySelector('.hamburger');
  if (!menuToggle) return;
  menuToggle.addEventListener('click', toggleMobileMenu);

  injectOnView();
});

window.addEventListener('scroll', () => {
  injectOnView();
});

window.addEventListener('load', () => {
  toggleCookieBanner();
  if (document.querySelector('.scroll-down-arrow')) smoothScrollSection();

  if (bookCard) loadBook();
});

setTapNativeCookieIfRequired();
